export const API_BASE_URL = process.env.NODE_ENV === 'development' 
  ? 'http://127.0.0.1/hotel-api' 
  : 'https://dinespark.bitsparktechnologies.com/hotel-api'; // the backend folder on cPanel
